<app-metric-card
  [title]="cardTitle"
  [currentValue]="newTicketData().value !== null ? newTicketData().value : 0"
  [suffix]="suffix"
  [hidePrevious]="true"
  [hideComparison]="true"
  [isLoading]="isLoading()"
>
</app-metric-card>
